import React from "react";
import { useSelector } from "react-redux";

import { BannerInline } from "../../bannerInline/BannerInline";
import { getRoamingDevicesLimits } from "../../../store/devices";
import { useIntlTranslate } from "../../../hooks";

import "./RoamingLimitReachedWarningReadonly.scss";

export const RoamingLimitReachedWarningReadonly = () => {
  const translate = useIntlTranslate();

  const { isRoamingLimitReached, roamingDevicesCount, roamingDevicesLimit } =
    useSelector(getRoamingDevicesLimits);

  if (!isRoamingLimitReached) return null;

  const message = translate("roaming_reached_limit_info", {
    b: (chunks) => <span className="strong">{chunks}</span>,
    roamingDevicesCount,
    roamingDevicesLimit,
  });

  return (
    <BannerInline
      className={"roaming-limit-reached-warning"}
      message={message}
    />
  );
};
